import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonUploadForm } from "../../../Pages/VideoLessons/Ivideolessons";

// 👇 Combine the interfaces to represent a full video upload item
export type IVideoUpload = VideoLessonUploadForm;

export const ListTopicSectionVideoSlice = createSlice({
  name: "ListTopicSectionVideoSlice",
  initialState: {} as IReduxState<IVideoUpload[]>,
  reducers: {
    listTopicSectionVideo: (state) => {
      state.isLoading = true;
    },

    successlistTopicSectionVideo: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistTopicSectionVideo: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listTopicSectionVideo,
  successlistTopicSectionVideo,
  failurelistTopicSectionVideo,
} = ListTopicSectionVideoSlice.actions;

export default ListTopicSectionVideoSlice.reducer;
